import styled from 'styled-components';
import PanelHeader from '@prisjakt/ui-panel-header';
import { layout } from '@prisjakt/ui-base';
import { TextInput } from '@prisjakt/ui-inputs';
import Button from '@prisjakt/ui-button';
import { colors, media } from '@prisjakt/ui-base/styles/variables';
import PriceHistory from '../product/components/price-history';
import FetchMore from './components/fetch-more';

export const PriceHistoryHeader = styled(PanelHeader)`
  padding: 0 ${layout.pageContent.gutter.rem};
`;

export const PriceHistoryGraph = styled(PriceHistory)`
  padding: 0 ${layout.pageContent.gutter.rem};
  /* Stabilize layout, reduce CLS */
  ${media.smallOnly`
    min-height: 224px;
  `}
  ${media.mediumOnly`
    min-height: 326px;
  `}
  ${media.largeUp`
    min-height: 455px;
  `}
`;

export const FetchMorePrices = styled(FetchMore)`
  padding: 0 ${layout.pageContent.gutter.rem};
  margin-bottom: ${layout.marginBottomSubComponent};
`;

export const ShareGraphLinkInput = styled(TextInput)`
  width: 400px;
`;

export const CopyLinkButton = styled(Button)`
  margin-top: 1.5em;
  margin-bottom: 1.5em;
`;

export const ShareGraphButton = styled(Button)`
  background: none;
  padding-top: 0;
  padding-bottom: 0;
  padding-right: 0;
  color: ${colors.lightBlue3};
  :hover {
    background: none;
    color: ${colors.lightTheme.maybeBlue500};
  }
  :focus {
    background: none;
    color: ${colors.lightTheme.maybeBlue500};
  }
`;
